module.exports = __webpack_public_path__ + "img/dash.075724b4.svg";